<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="realtorProfiles" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="realtorProfileId"
  selectionMode="single" [(selection)]="realtorProfileSelection" [loading]="loading" [paginator]="showPagination"
  [rows]="50" [rowsPerPageOptions]="[50,100,200,500,1000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Realtor Profiles</h1>
      <span>
        <div class="mt-2">
          <app-search-template [realtorProfile]=true removeTagLabel="Remove Tag" applyTagLabel="Apply Tag"
            [showApplyTagButton]=true [showRemoveTagButton]="true" [showAddTag]=true
            (doApplyTagCB)="onSearchSubmit($event)"
          (doRemoveTagCB)="onSearchSubmit($event)"></app-search-template>
          @if (showTagValidation) {
            <div class="text-danger">Please select the tag.</div>
          }
          @if (showRowSelectionValidation) {
            <div class="text-danger">Please select atleast one row to apply
            selected tag.</div>
          }
          &nbsp;&nbsp;
          <!--clear filters-->
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>

          <!--add new-->
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New RealtorProfile +</button>

          <button pButton pRipple type="button" class="p-button-success ms-2" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
            [icon]="exportToExcelLoading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel'"
            [label]="exportToExcelLoading ? 'Exporting...' : 'Export to Excel'"
            (click)="exportToExcel()"
            [disabled]="exportToExcelLoading">
          </button>
        </div>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th></th>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}">Tags</th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th>
          <p-tableHeaderCheckbox [value]="realtorProfile" style="margin-left: 5px;"></p-tableHeaderCheckbox>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
        type="text" (input)="pt.filter($event.target.value, 'realtorProfileId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
        type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
        type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
        type="text" (input)="pt.filter($event.target.value, 'emailAddress', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
        type="text" (input)="pt.filter($event.target.value, 'mobilePhone', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
        type="text" (input)="pt.filter($event.target.value, 'adrCompanyName', 'in')"></th>
        <th>
          <p-multiSelect [options]="listingStatuses" displaySelectedLabel defaultLabel="Select Status"
            optionLabel="name" appendTo="body" (onChange)="pt.filter($event.value, 'listingStatus', 'in')"
          display="chip"></p-multiSelect>
        </th>
        <th>
          <p-multiSelect [options]="realtorProfileSubjAdrStateList" displaySelectedLabel
            defaultLabel="Select State" optionLabel="name" appendTo="body"
          (onChange)="pt.filter($event.value, 'adrState', 'in')" display="chip"></p-multiSelect>
        </th>
        <th>
          <p-multiSelect (onChange)="pt.filter($event.value, 'adrIsland', 'in')"
            [options]="realtorProfileSubAdrIslandList" displaySelectedLabel defaultLabel="Select Island"
            optionLabel="name" appendTo="body" display="chip">
          </p-multiSelect>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><app-tag-join-filter-select [tagSource]="90"
        (getFilteredTags)="getFilteredTags($event)"></app-tag-join-filter-select></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-realtorProfile>
    <tr (click)="onOpenFormEdit(realtorProfile)">
      <td>
        <p-tableCheckbox [value]="realtorProfile"></p-tableCheckbox>
      </td>
      <td>{{realtorProfile.realtorProfileId}} </td>
      <td>{{realtorProfile.firstName}}</td>
      <td>{{realtorProfile.lastName}}</td>
      <td>{{realtorProfile.emailAddress}}</td>
      <td>{{realtorProfile.mobilePhone}}</td>
      <td>{{realtorProfile.adrCompanyName}}</td>
      <td>{{realtorProfile.listingStatus}}</td>
      <td>{{realtorProfile.adrState}}</td>
      <td>{{realtorProfile.adrIsland}}</td>
      <app-tag-join-list-select [tagSource]="90" [tagSourceId]="realtorProfile.realtorProfileId"
      tagType="4"></app-tag-join-list-select>
      <!-- <td>{{getStatusName(realtorProfile)}}</td> -->
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(realtorProfile)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>